<template>
    <!-- <keep-alive  :include="keepalivePageArr"> -->
        <router-view ref="NestHome"></router-view>
    <!-- </keep-alive> -->
</template>

<script>
export default {
    data() {
        return {};
    },
    // computed: {
    //   keepalivePageArr() {
    //     return this.$store.state.tagsView.keepalivePageArr
    //   },
    // },
    created() {},
    methods:{
    },
};
</script>
